import AgreementType from 'components/blocks/Delta/Inputs/AgreementType';
import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputIPF from 'components/blocks/ManagementNewForms/Inputs/FormInputIPF'; import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity';
import React, { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm } from 'react-hook-form';
import FormInputTable, { fillArray } from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import Loader from 'components/blocks/Loader/Loader';
import useCreateDeclaracionJuradaGarantiasLaborales from 'services/record/DeclaracionJuradaGarantiasLaborales/useCreateDeclaracionJuradaGarantiasLaborales';
import useUpdateDeclaracionJuradaGarantiasLaboralesByID from 'services/record/DeclaracionJuradaGarantiasLaborales/useUpdateDeclaracionJuradaGarantiasLaborales';
import InputTextIntegration from 'components/blocks/ManagementNewForms/Inputs/InputTextIntegration';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';


const DeclaracionJuradaGarantiasLaborales = ({ info, dataUser, onSuccess }: { info: boolean; dataUser: any, onSuccess?: () => void }) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;

    const { createDeclaracionJuradaGarantiasLaborales, dataCreateDeclaracionJuradaGarantiasLaborales, errorCreateDeclaracionJuradaGarantiasLaborales, loadingCreateDeclaracionJuradaGarantiasLaborales, successCreateDeclaracionJuradaGarantiasLaborales } = useCreateDeclaracionJuradaGarantiasLaborales();
    const { dataUpdateDeclaracionJuradaGarantiasLaboralesById, errorUpdateDeclaracionJuradaGarantiasLaboralesById, loadingUpdateDeclaracionJuradaGarantiasLaboralesById, successUpdateDeclaracionJuradaGarantiasLaboralesById, updateDeclaracionJuradaGarantiasLaboralesById } = useUpdateDeclaracionJuradaGarantiasLaboralesByID();

    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);

    const validateTrabajadoresACargo = (rows: any[]) => {
        if (!Array.isArray(rows) || rows.length === 0) return true;

        const allRowsComplete = rows.every((row) => {
            if (!row || typeof row !== 'object') return false;

            const values = [row.NombreApellidos, row.IPF];
            return values.every((value) => String(value ?? '').trim() !== '');
        });

        return allRowsComplete || 'Debes completar todos los campos de cada trabajador añadido';
    };

    const adaptApiResponseToDefaultValues = (data: any) => {
        if (data) {

            reset({
                // =====================================================
                // DATOS PERSONALES
                // =====================================================
                DatosPersonales: {
                    SolicitanteNombre: data?.DatosPersonales?.Nombre || "",
                    SolicitanteApellido1: data?.DatosPersonales?.Apellido1 || "",
                    SolicitanteApellido2: data?.DatosPersonales?.Apellido2 || "",
                    SolicitanteIPF: data?.DatosPersonales?.IPF || "",
                    SolicitanteIPFTipo: data?.DatosPersonales?.IPFTipo?.toString() || "1",
                    SolicitanteNombreCompleto: data?.DatosPersonales?.Nombre + " " + data?.DatosPersonales?.Apellido1 + " " + data?.DatosPersonales?.Apellido2 || "",
                    SolicitanteTelefono: data?.DatosPersonales?.Telefono || "",
                    SolicitanteFijo: data?.DatosPersonales?.Fijo || "",
                    SolicitanteDomicilio: data?.DatosPersonales?.Domicilio || "",
                    SolicitanteCodigoPostal: data?.DatosPersonales?.CodigoPostal || "",
                    SolicitanteProvincia: data?.DatosPersonales?.CodigoProvincia || "",
                    SolicitanteProvinciaDescripcion: data?.DatosPersonales?.Provincia || "",
                    SolicitanteComunidadCodigo: data?.DatosPersonales?.ComunidadCodigo || "",
                },

                // =====================================================
                // CESE
                // =====================================================
                Cese: {
                    FechaMotivoCese:
                        data?.FechaCeseActividad || null,

                    TrabajadoresACargo: fillArray(data?.TrabajadoresACargo, 0, null),
                },


            });
        }

    }

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);




    const onSubmit = async (data: any) => {
        console.log(data);
        setLoader(true);

        let prestacionId = dataUser?.PrestacionId || null;

        const datosEnvio = {
            // IDENTIFICACIÓN
            Id: dataUser?.Id || null,
            ExternalId: dataUser?.ExternalId || 0,
            PersonaId: dataUser?.PersonaId || 0,
            UsuarioId: dataUser?.UsuarioId || null,
            ExpedienteId: dataUser?.ExpedienteId || null,
            PrestacionId: prestacionId,

            Acepto: data?.Acepto ?? false,

            // -----------------------------------
            // DATOS PERSONALES
            // -----------------------------------
            datosPersonales: {
                nombre: dataUser?.DatosPersonales?.Nombre ?? dataUser?.datosPersonales?.nombre ?? "",
                apellido1: dataUser?.DatosPersonales?.Apellido1 ?? dataUser?.datosPersonales?.apellido1 ?? "",
                apellido2: dataUser?.DatosPersonales?.Apellido2 ?? dataUser?.datosPersonales?.apellido2 ?? "",
                ipf: dataUser?.DatosPersonales?.IPF ?? dataUser?.datosPersonales?.ipf ?? "",
                ipfTipo: dataUser?.DatosPersonales?.IPFTipo ?? dataUser?.datosPersonales?.ipfTipo ?? 1,
                telefono: dataUser?.DatosPersonales?.Telefono ?? dataUser?.datosPersonales?.telefono ?? "",
                fijo: dataUser?.DatosPersonales?.Fijo ?? dataUser?.datosPersonales?.fijo ?? "",
                domicilio: dataUser?.DatosPersonales?.Domicilio ?? dataUser?.datosPersonales?.domicilio ?? "",
                codigoPostal: dataUser?.DatosPersonales?.CodigoPostal ?? dataUser?.datosPersonales?.codigoPostal ?? "",
                provinciaDescripcion: dataUser?.DatosPersonales?.ProvinciaDescripcion ?? dataUser?.DatosPersonales?.Provincia ?? dataUser?.datosPersonales?.provinciaDescripcion ?? "",
                codigoProvincia: dataUser?.DatosPersonales?.CodigoProvincia ?? dataUser?.datosPersonales?.codigoProvincia ?? "",
                codigoLocalidad: dataUser?.DatosPersonales?.CodigoLocalidad ?? dataUser?.datosPersonales?.codigoLocalidad ?? "",
                localidadDescripcion: dataUser?.DatosPersonales?.LocalidadDescripcion ?? dataUser?.datosPersonales?.localidadDescripcion ?? "",
                numeroSeguridadSocial: dataUser?.DatosPersonales?.NumeroSeguridadSocial ?? dataUser?.datosPersonales?.numeroSeguridadSocial ?? ""
            },
            fechaCeseActividad:
                data?.Cese?.FechaMotivoCese || null,
            trabajadoresACargo: data?.Cese?.TrabajadoresACargo || null,
        }

        if (info) {
            await createDeclaracionJuradaGarantiasLaborales(dataUser?.UsuarioId.toString(), datosEnvio, onSuccess)
            setBloquearEnvio(true);
        } else {
            await updateDeclaracionJuradaGarantiasLaboralesById(dataUser?.Id, dataUser?.Id, datosEnvio)
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <Loader activeLoader={loader || loadingCreateDeclaracionJuradaGarantiasLaborales || loadingUpdateDeclaracionJuradaGarantiasLaboralesById} label="Cargando Formulario"></Loader>








                {/* ////////////// COMIENZO FORMULARIO ////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario ?? dataUser?.EstadoFormulario ?? dataUser?.estadoFormulario}
                    estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.estadoFormularioDescripcion ?? dataUser?.EstadoFormularioDescripcion ?? dataUser?.estadoFormularioDescripcion}
                    fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado ?? dataUser?.FechaActualizacionEstado ?? dataUser?.fechaActualizacionEstado}
                />
                <FieldsetContainer legend="" disabled={false}>

                    <p className=' mb-2 text-left parra-bold'>D./Dña
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteNombreCompleto"
                            inputType={1}
                            disabled={true}
                            minWidth={300}
                        />
                        mayor de edad, con domicilio en
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteDomicilio"
                            inputType={1}
                            disabled={true}
                            minWidth={500}
                        />
                        con DNI/NIE/Pasaporte
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteIPF"
                            inputType={1}
                            disabled={true}
                        />
                        actuando en mi propio nombre y derecho


                    </p>
                    <p className='mb-4'>
                        DECLARO RESPONSABLEMENTE, a efectos del cumplimiento de los requisitos para el derecho a la protección por cese de actividad de los trabajadores autónomos, en el Real Decreto Legislativo 8/2015, de 30 de octubre,por el que se aprueba el texto refundido de la Ley General de la Seguridad Social
                    </p>

                </FieldsetContainer>
                <div className='m-3'></div>


                <div className="row mb-4">
                    <div className="col-xl-12">


                        <FieldsetContainer legend="" disabled={false}>

                            <p className='mb-3'>
                                Haber cumplido, con anterioridad al
                                <InputTextIntegration
                                    name={'Cese.FechaMotivoCese'}
                                    inputType={4}
                                    req='La fecha de cese es obligatoria'
                                />
                                fecha de cese de mi actividad, y
                                respecto de todos los trabajadores a mi cargo, con las garantías, obligaciones y procedimientos regulados en
                                la legislación laboral
                            </p>
                            <p className='mb-3'>
                                Haber comunicado el cese definitivo/temporal de mi actividad a la Tesorería General de la
                                Seguridad Social o Instituto Social de la Marina, así como las bajas en el correspondiente régimen de los
                                trabajadores a mi cargo, en los términos indicados en los artículos 18 y 29.1 del Real Decreto 84/1996, de 26
                                de enero, por el que se aprueba el Reglamento General sobre inscripción de empresas y afiliación, altas, bajas
                                y variaciones de datos de trabajadores en la Seguridad Social.
                            </p>
                            <FormInputTable
                                name="Cese.TrabajadoresACargo"
                                heads={["Nombre y apellidos del Trabajador", "DNI/NIF/NIE/Pasaporte"]}
                                nameHeads={["NombreApellidos", "IPF"]}
                                removeButton={true}
                                addButton={true}
                                widthColumn={[3, 1]}
                                validateFunction={validateTrabajadoresACargo}
                                inputType={[1, 1]}
                                arrayModal={[null, ""]}
                            />

                        </FieldsetContainer>
                    </div>
                </div>

















                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreateDeclaracionJuradaGarantiasLaborales}
                    successUpdate={successUpdateDeclaracionJuradaGarantiasLaboralesById}
                    errorCreate={errorCreateDeclaracionJuradaGarantiasLaborales}
                    errorUpdate={errorUpdateDeclaracionJuradaGarantiasLaboralesById}
                    datosAPI={datosAPI}
                    info={info}
                    BloqueoForm={[1]}

                />


                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default DeclaracionJuradaGarantiasLaborales
